import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../plugins/axios';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state: {
    user: null
  },

  mutations: {
    ['SET_USER'](state, user) {
      state.user = user
    }
  },

  actions: {
    async authUser({ commit }) {
      try {
        const { data } = await axios.get('/api/auth');
        commit('SET_USER', data)
      } catch(err) {
        console.log('Auth user failed: ' + err.message);
      }
    },
    async login({ commit }, data) {
      localStorage.setItem('Authorization', data.token);
      commit('SET_USER', { ...data.user, logined: true });
    },
    async logout({ commit }) {
      localStorage.clear();
      commit('SET_USER', null);
    }
  },
  strict: debug,
})
